import { render, staticRenderFns } from "./UserGroupItem.vue?vue&type=template&id=427d335a&scoped=true"
import script from "./UserGroupItem.vue?vue&type=script&lang=js"
export * from "./UserGroupItem.vue?vue&type=script&lang=js"
import style0 from "./UserGroupItem.vue?vue&type=style&index=0&id=427d335a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427d335a",
  null
  
)

export default component.exports